// Switches between Arabic and English. Because the direction lives on the
// <html> element, one click mirrors the entire layout.

import { Languages } from 'lucide-react';
import clsx from 'clsx';
import { useI18n } from '../../i18n/I18nProvider';

export function LanguageSwitcher({ variant = 'dark' }: { variant?: 'dark' | 'light' }) {
  const { locale, setLocale, t } = useI18n();

  return (
    <div
      className={clsx(
        'inline-flex items-center gap-1 rounded-control border p-0.5',
        variant === 'light'
          ? 'border-warm-cream/25 bg-deep-green/40'
          : 'border-line-strong bg-surface',
      )}
      role="group"
      aria-label={t.common.language}
    >
      <Languages
        className={clsx('mx-1.5 h-4 w-4', variant === 'light' ? 'text-warm-cream/70' : 'text-ink-muted')}
        aria-hidden="true"
      />

      {(['ar', 'en'] as const).map((option) => {
        const active = locale === option;
        return (
          <button
            key={option}
            type="button"
            onClick={() => setLocale(option)}
            aria-pressed={active}
            className={clsx(
              'rounded-[6px] px-2.5 py-1 text-xs font-semibold transition-colors duration-150',
              active
                ? variant === 'light'
                  ? 'bg-warm-cream text-deep-green'
                  : 'bg-butcher-green text-white'
                : variant === 'light'
                  ? 'text-warm-cream/75 hover:text-warm-cream'
                  : 'text-ink-muted hover:text-ink',
            )}
          >
            {option === 'ar' ? t.common.arabic : t.common.english}
          </button>
        );
      })}
    </div>
  );
}
